import request from "@/utils/request";

// 预约相关API

// 预约成功列表
function yuyue_list(params) {
  return request({
    url: "api/app/brand.php?action=brandlist&",
    method: "get",
    params,
  });
}

// 预约成功排行榜
function yuyue_rank(params) {
  return request({
    url: "api/app/brand.php?action=brandsort&",
    method: "get",
    params,
  });
}

// 预约下单
function yuyue(params) {
  return request({
    url: "api/app/form.php?action=add&",
    method: "get",
    params,
  });
}

// 检查城市
function check_city(params) {
  return request({
    url: "api/app/citys.php?",
    method: "get",
    params,
  });
}

//预约记录
function yuyue_record(params) {
  return request({
    url: "api/app/brand.php?action=brandorder&",
    method: "get",
    params,
  });
}

//预约记录
function yuyue_remove(params) {
  return request({
    url: "api/app/brand.php?action=delete&",
    method: "get",
    params,
  });
}

//定订单状态提示
function order_tips(params) {
  return request({
    url: "api/app/gonggao.php?code=alipaysetting",
    method: "get",
    params,
  });
}
export {
  yuyue_list,
  yuyue_rank,
  yuyue,
  check_city,
  yuyue_record,
  yuyue_remove,
  order_tips,
};
